/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.


//!=== Production Amplify
const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cognito_identity_pool_id": "ap-southeast-1:7241c503-c4b0-4314-9095-eeb1d57bbe5b",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_f0JvPkyvf",
    "aws_user_pools_web_client_id": "6e5khjptbipgtlopo7f0f1tmtc",
    "oauth": {},
    "aws_user_files_s3_bucket": "hrcentralized-prod-my",
    "aws_user_files_s3_bucket_region": "ap-southeast-5"
};

//!=== Development Amplify
// const awsmobile = {
//     "aws_project_region": "ap-southeast-1",
//     "aws_cognito_identity_pool_id": "ap-southeast-1:ee838731-8d68-4e24-8ef9-926e4123323e",
//     "aws_cognito_region": "ap-southeast-1",
//     "aws_user_pools_id": "ap-southeast-1_KYuQcPUUl",
//     "aws_user_pools_web_client_id": "39ikvktqm6ug69us2le68pcecd", 
//     "oauth": {},
//     "aws_user_files_s3_bucket": "hrcentralizedapp-dev-my",
//     "aws_user_files_s3_bucket_region": "ap-southeast-5"
// };


export default awsmobile;


